import React, { Component } from 'react';
import { Tabs, Tab, Grid, Cell, Card, CardTitle, CardText, CardActions, Button, CardMenu, IconButton } from 'react-mdl';
import { Slide , Slideshow } from './slide.js';
import 'tachyons';

class Projects extends Component {
  

  constructor(props) {
    super(props);
    this.state = { activeTab: 0 };
  }
  toggleCategories() {

    if(this.state.activeTab === 0){
      return(
        <div className="projects-grid" >
          {/* Project 1 */}
          <Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/TTvDYVc/clock.png) center / cover'}} ></CardTitle>
            <CardText><b>JSClock</b><br></br>
              Simple Clock <br></br>
              Tools: HTML5,CSS3,VanillaJS
            </CardText>
           
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>

          {/* Project 2 */}
          <Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/6ZDWddQ/tetris.png) center / cover'}} ></CardTitle>
            <CardText style={{ fontfamily: 'Georgia'}}>
            <b>Tetris</b><br></br>
            Simple Game <br></br>Tools:HTML5,CSS3,JavaScript.

            </CardText>
            
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>

          {/* Project 3 */}
          <Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/TcHfJny/spaceinvaders.png) center / cover'}} ></CardTitle>
            <CardText >
                        <b>SpaceInvaders</b><br></br>
             Simple Game<br></br>Tools:HTML5,CSS3,JavaScript.

            </CardText>
          
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>

        </div>


      )
}
    if(this.state.activeTab === 1){
      return(
        <div className="projects-grid" >
          {/* Project 1 */}
              
          <Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/6Dzd2RM/react1.png) center / cover'}} ></CardTitle>
            <CardText><b>RoboFriends</b><br></br>
              Simple App that fetchs an api and shows data of robots<br></br>
              Tools: Reactjs
            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>

    <Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/jWrRWZZ/SPACE.png) center / cover'}} ></CardTitle>
            <CardText><b>SpaceX</b><br></br>
              Simple App to shows data about planets <br></br>with a 2D/3D solar system.<br></br>
              Tools: Reactjs,Jquery,Pure CSS
            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>


         


      <Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/j4VD3wh/tour.png) center / cover'}} ></CardTitle>
            <CardText style={{ fontfamily: 'Georgia'}}>
            <b>TunisiaTour App</b><br></br>
            Simple App to show best touristic places in Tunisia<br></br>Tools:React,Bootstrap,Sass.

            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
                 
      

          {/* Project 2 */}
          <Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/K9WXTWr/Cooking-app.png) center / cover'}} ></CardTitle>
            <CardText style={{ fontfamily: 'Georgia'}}>
            <b>Recipe Finder App</b><br></br>
            Simple App to find recipe using a recipe api<br></br>Tools:React,Bootstrap,Jquery,Recipe API

            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>

    

          {/* Project 3 */}
          <Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/n1b9jdc/imdb.png) center / cover'}} ></CardTitle>
            <CardText >
                        <b>CinemaCafe</b><br></br>
             App to present films and shows using a omdbapi<br></br>Tools:React,Redux,omdb API.

            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>




          <Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/WgpT8CW/store.png) center / cover'}} ></CardTitle>
            <CardText><b>TechStore</b><br></br>
              E-commerce Website to sell phones.<br></br>
              Tools: Bootstrap,Reactjs,Netlify.
            </CardText>
            
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>





        </div>


      )
    } else if(this.state.activeTab === 2) {
      return (
        <div className="projects-grid"><Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/LNy5rrm/Angular-Js.png) center / cover'}} ></CardTitle>
            <CardText>
            <b>HomeSweetHome</b><br></br>
              Simple House Selling Management App  <br></br> Tools:AngularJs
            </CardText>
          
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card></div>

      )
    } else if(this.state.activeTab === 3) {
     return (
        <div className="projects-grid"><Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/KNqxxP6/list.png) center / cover'}} ></CardTitle>
            <CardText><b>ToDoS</b><br></br>
              A simple todo list   <br></br> Tools:Express,Jquery,MongoDB,NodeJS.
            </CardText>
          
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card></div>

      )
    } else if(this.state.activeTab === 4) {
      return (
         <div className="projects-grid">

          {/* Project 1 */}
          <Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/x8twQ8J/C.png) center / cover'}} ></CardTitle>
            <CardText>
                       <b> DOPens</b><br></br>
              App to Donate Pens to school<br></br>Tools:C#,Bunifu,LINQ,CRUD,VisualStudio. 

            </CardText>
           
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>

          {/* Project 2 */}
         

          {/* Project 3 */}
                  </div>
      )
    }
else if(this.state.activeTab === 5) {
      return (
        <div className="projects-grid"><Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/sVCrLyF/wordpress.png) center / cover'}} ></CardTitle>
            <CardText><b>Beautiful Places</b><br></br>
              Website to display images  <br></br> Tools:Wordpress themes and plugins.
            </CardText>
          
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card></div>

      )
    }

else if(this.state.activeTab === 6) {
      return (
        <div className="projects-grid">
        <Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/Ypv3rf9/php.png) center / cover'}} ></CardTitle>
            <CardText>
           <b> Montres et CO</b><br></br>
              E-commerce Website<br></br>Tools:HTML5,CSS3,Bootstrap,<br></br>php,phpmyadmin.
            </CardText>
         
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
        <Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/CzMxq32/j.png) center / cover'}} ></CardTitle>
            <CardText>
           <b> JobLister</b><br></br>
              Dashboard to list jobs<br></br>Tools:Bootstrap,php,phpmyadmin.
            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>




          </div>

      )
    }
    else if(this.state.activeTab === 7) {
      return (
        <div className="projects-grid"><Card className="grow bw2 shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/vkV8y79/java.png) center / cover'}} ></CardTitle>
            <CardText>
           <b> ConferneceManager</b><br></br>
              App to create and manage conferences <br></br>Tools:Java,Derby,JFX,NetBeans.
            </CardText>
         
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card></div>

      )
    }


else if(this.state.activeTab === 8) {
      return (
        <div className="projects-grid"><Card className="grow shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/JrBn59w/D3.png) center / cover'}} ></CardTitle>
            <CardText><b>CO2 Dashboard</b><br></br>
              Website to visualise data on CO2 during 10 years all over the world  <br></br> Tools:D3
            </CardText>
       
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card></div>

      )
    }

else if(this.state.activeTab === 9) {
      return (
        <div className="projects-grid"><Card className="grow shadow-5" shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.ibb.co/PDNBJ6m/egg.png) center / cover'}} ></CardTitle>
            <CardText><b>EggCatcher</b><br></br>
              Simple Game  <br></br> Tools:Python,Tinker.

            </CardText>
          
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card></div>

      )
    }










  }



  render() {
    return(
      <div>
        <Tabs activeTab={this.state.activeTab} onChange={(tabId) => this.setState({ activeTab: tabId })} ripple>
                   <Tab>JavaScript</Tab>
          <Tab>React</Tab>
          <Tab>Angular</Tab>
          <Tab>Express</Tab>
          <Tab>C#</Tab>
          <Tab>Wordpress</Tab>
          <Tab>Php/Mysql</Tab>
          <Tab>Java</Tab>
          <Tab>D3</Tab>
          <Tab>Python</Tab>


        </Tabs>


          <Grid>
            <Cell col={12}>
              <div className="content">{this.toggleCategories()}</div>
            </Cell>
          </Grid>


      </div>
    )
  }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/components/projects.js